(() => {
  const SECTION_SELECTOR = '[data-collection-list]';
  const SECTION_READY_EVENT = 'rpd:deferred-section:ready';
  const HYDRATE_IMAGES_EVENT = 'rpd:deferred-card-images:hydrate';

  const hydrateHiddenImages = (section) => {
    document.dispatchEvent(
      new CustomEvent(HYDRATE_IMAGES_EVENT, {
        detail: {
          scope: section,
          includeHidden: true,
        },
      })
    );
  };

  const bindToggle = (section) => {
    if (!section) return;

    const toggle = section.querySelector('[data-collection-toggle]');
    if (!toggle || toggle.dataset.bound === 'true') return;

    toggle.dataset.bound = 'true';

    const expandedClass = toggle.getAttribute('data-expanded-class');
    const collapsedClass = toggle.getAttribute('data-collapsed-class');
    const labelExpanded = toggle.getAttribute('data-label-expanded');
    const labelCollapsed = toggle.getAttribute('data-label-collapsed');

    const applyState = (isOpen) => {
      if (expandedClass) toggle.classList.remove(expandedClass);
      if (collapsedClass) toggle.classList.remove(collapsedClass);

      const nextClass = isOpen ? expandedClass : collapsedClass;
      if (nextClass) toggle.classList.add(nextClass);

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.textContent = isOpen ? labelExpanded : labelCollapsed;
    };

    applyState(section.classList.contains('collection-list-section--show-all'));

    toggle.addEventListener('click', () => {
      const isOpen = section.classList.toggle('collection-list-section--show-all');
      if (isOpen) hydrateHiddenImages(section);
      applyState(isOpen);
    });
  };

  const scheduleInit = (section) => {
    if (!section || section.dataset.collectionListInitScheduled === 'true') return;
    section.dataset.collectionListInitScheduled = 'true';

    const run = () => {
      bindToggle(section);
    };

    if (
      section.dataset.deferredSectionReady === 'true' ||
      !section.hasAttribute('data-deferred-section') ||
      (window.Shopify && window.Shopify.designMode)
    ) {
      run();
      return;
    }

    section.addEventListener(SECTION_READY_EVENT, run, { once: true });
  };

  const init = (scope) => {
    if (!scope) return;

    const sections = [];
    if (scope.matches?.(SECTION_SELECTOR)) sections.push(scope);
    sections.push(...(scope.querySelectorAll?.(SECTION_SELECTOR) || []));

    sections.forEach((section) => {
      scheduleInit(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    init(event.target);
  });
})();
